import { useController } from "react-hook-form";
import { useCallback, useEffect } from "react";
import store, { useAppSelector } from "../../../../global/utils/redux/store";
import CustomField from "../../../../types/shared/CustomField";
import { setOrderCustomField } from "../../../../global/utils/redux/customFieldsSlice";
import isKiosk from "../../../../global/utils/helpers/isKiosk";

function validateRange(range: string, value: string) {
  const result = [];
  const parts = range.split(",") ?? [];

  for (const part of parts) {
    if (part.includes("-")) {
      const [start, end] = part.split("-").map(Number);
      for (let i = start; i <= end; i++) {
        result.push(i.toString());
      }
    } else {
      result.push(part);
    }
  }

  return result.includes(value.replace(/^0+/, "")) ? true : "pagerNr.error-message";
}

export default function useCustomField(customField: CustomField, extraRules: any = null) {
  const orderCustomField = useAppSelector((state) => state.customFields.orderCustomFields[customField.name]);
  const defaultValue = orderCustomField?.value ?? customField.defaultValue;

  const pattern = customField.pattern && isKiosk() ? new RegExp(customField.pattern) : undefined;

  const {
    field: { value, onChange },
  } = useController({
    name: customField.name,
    defaultValue,
    rules: {
      required: customField.required,
      ...extraRules,
      pattern,
      validate: (value: string) => {
        if (customField.range) {
          return validateRange(customField.range, value);
        }
        return true;
      },
    },
  });

  useEffect(() => {
    if (defaultValue && defaultValue != orderCustomField?.value) {
      store.dispatch(setOrderCustomField({ customFieldName: customField.name, value: defaultValue }));
    }
  }, [customField.name, defaultValue, orderCustomField?.value]);

  const setCustomField = useCallback(
    (value: any) => {
      onChange(value);
      store.dispatch(setOrderCustomField({ customFieldName: customField.name, value: value }));
    },
    [onChange, customField]
  );

  return { setCustomField, value };
}
